import { InputMask } from '@react-input/mask';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Select, { StylesConfig } from "react-select";
import TextField from '../../../../core/common/textFields/TextField';
import { removeImage, setImage } from '../../../../Features/commonSlice';
import { useGetContactLookupQuery, useUpdateContactMutation } from "../../../../services/EndPointsApis";
import { RootState } from '../../../../store';
import { TimePicker, TimePickerProps } from "antd";
import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";
import { toast } from 'react-toastify';
import { inputMaskNumber } from '../../../../core/common/textFields/NumberField';

const ContactWizData = ({ activityTogglePopup, AccountId, AccountName, closeSidebar, isEditing, toogle, setToogle, viewOnly, contactData, formik, isSuccess, isError, error, data, refetch }: any) => {

  const dispatch = useDispatch();
  const customStyles: StylesConfig = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "rgba(177, 31, 40, 1)",
      },
    }),
  };
  const [updateId, setUpdateId] = useState(0);
  const imageUrl = useSelector((state: RootState) => state.common?.imageUrl);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  // const [UpdateContact, { data: updatedata, isError: updateIsError, error: updateError, isSuccess: updateIsSuccess, }] =
  //     useUpdateContactMutation();
  const { data: getContactLookup, refetch: refetchContactLookups } = useGetContactLookupQuery('');

  // const { data: allAccounts, refetch: allAccountsRefetch } = useGetAllAccountsQuery('');

  dayjs.extend(customParseFormat);

  const onChangePrimaryTime: TimePickerProps['onChange'] = (time, timeString) => {
    const formattedTime = time ? dayjs(time).format("h:mm A") : '';
    formik.setFieldValue('primaryContact.perferredTime', formattedTime);
  };

  const onChangeSecondaryTime: TimePickerProps['onChange'] = (time, timeString) => {
    const formattedTime = time ? dayjs(time).format("h:mm A") : '';
    formik.setFieldValue('secondaryContact.perferredTime', formattedTime);
  };


  const hideShowDiv = () => {
    setToogle((prev: any) => !prev)
  }

  const handleContactType = (selectedOption: any) => {
    formik.setFieldValue(' inquiryMethod', selectedOption);
  };
  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      dispatch(setImage(imageUrl));
      formik.setFieldValue('imageUrl', imageUrl);
      formik.setFieldValue('file', file);
    }
  };
  const handleRemoveImage = () => {
    dispatch(removeImage());
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const [primaryHEmailErr, setPrimaryHEmailErr] = useState(false)
  const [primaryWEmailErr, setPrimaryWEmailErr] = useState(false)
  const [secHEmailErr, setSecHEmailErr] = useState(false)
  const [secWEmailErr, setSecWEmailErr] = useState(false)


  // useEffect(() => {
  //     if (!activityTogglePopup && !isEditing && !contactData) {
  //         resetForm();
  //     }
  //     if (AccountId && AccountName) {
  //         formik.setFieldValue('lst_Account.id', AccountId);
  //         formik.setFieldValue('lst_Account.value', AccountName);
  //     }
  // }, [activityTogglePopup]);

  const handleSubmit = (event: any) => {
    event.preventDefault();
    formik.handleSubmit()
  }

  return (
    <div className='row mt-3'>
      <h5 className=' mb-2'>Primary Contact</h5>
      <>
        <div className="col-md-12">
          <div className="form-wrap">
            <label className="input-label">
              Contact Type{" "} <span className="text-danger">*</span>
            </label>
            <Select
              styles={customStyles}
              className="select"
              options={getContactLookup?.result?.contactTypes?.map((option: any) => ({
                label: option?.name,
                value: option?.id
              }))}
              isDisabled
              value={
                formik.values?.primaryContact?.contactType?.id
                  ? {
                    value: formik.values?.primaryContact?.contactType?.id || 17,
                    label: formik.values?.primaryContact?.contactType?.name || 'Primary Contact',
                  }
                  : null
              }
              onChange={(selectedOption: any) => {
                formik.setFieldValue('primaryContact.contactType.id', selectedOption.value);
                formik.setFieldValue('primaryContact.contactType.name', selectedOption.label);

              }}
            />
          </div>
          {/* {formik.touched.contactType && formik.errors.contactType && (
              <div className="error">{formik.errors.contactType?.id}</div>
            )} */}
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <TextField
              label="Company Name"
              type="text"
              {...formik.getFieldProps("primaryContact.companyName")}
              disabled={viewOnly}
            />
          </div>

        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className="input-label">
              Salutation{" "} <span className="text-danger">*</span>
            </label>
            <Select
              styles={customStyles}
              className="select"
              options={getContactLookup?.result?.salutationTypes?.map((option: any) => ({
                label: option?.name,
                value: option?.id
              }))}
              value={
                formik.values?.primaryContact?.salutation?.id
                  ? {
                    value: formik.values?.primaryContact?.salutation?.id,
                    label: formik.values?.primaryContact?.salutation?.name || '',
                  }
                  : null
              }
              isDisabled={viewOnly}
              onChange={(selectedOption: any) => {
                formik.setFieldValue('primaryContact.salutation.id', selectedOption.value);
                formik.setFieldValue('primaryContact.salutation.name', selectedOption.label);

              }}
            />
          </div>
          {/* {formik.touched.salutation?.id && formik.errors.salutation?.id && (
              <div className="error">{formik.errors.salutation?.id}</div>
            )} */}
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <TextField
              label=" First Name"
              type="text"
              required
              {...formik.getFieldProps("primaryContact.firstName")}
              disabled={viewOnly}
            />
          </div>
          {/* {formik.touched.firstName && formik.errors.firstName && (
              <div className="error">{formik.errors.firstName}</div>
            )} */}
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <TextField
              label="Last Name"
              type="text"
              required
              {...formik.getFieldProps("primaryContact.lastName")}
              disabled={viewOnly}
            />
          </div>
          {/* {formik.touched.lastName && formik.errors.lastName && (
              <div className="error">{formik.errors.lastName}</div>
            )} */}
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <TextField
              label="Address As"
              type="text"
              {...formik.getFieldProps("primaryContact.addressAs")}
              disabled={viewOnly}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className="input-label">Marital Status</label>
            <Select
              styles={customStyles}
              className="select"
              options={getContactLookup?.result?.maritalStatusTypes?.map((option: any) => ({
                label: option?.name,
                value: option?.id
              }))}
              value={
                formik.values?.primaryContact?.maritalStatus?.id
                  ? {
                    value: formik.values?.primaryContact?.maritalStatus?.id,
                    label: formik.values?.primaryContact?.maritalStatus?.name || '',
                  }
                  : null
              }
              isDisabled={viewOnly}
              onChange={(selectedOption: any) => {
                formik.setFieldValue('primaryContact.maritalStatus.id', selectedOption.value);
                formik.setFieldValue('primaryContact.maritalStatus.name', selectedOption.label);

              }}
            />
          </div>
        </div>
        <h5 className=' mb-2'>
          Contact Information
        </h5>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className='input-label'>
              Home Phone
            </label>
            <InputMask mask={inputMaskNumber}
              replacement={{ _: /\d/ }}
              className="form-control"
              {...formik.getFieldProps("primaryContact.homePhone")}
              disabled={viewOnly}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className='input-label'>
              Work Phone
            </label>
            <InputMask mask={inputMaskNumber}
              replacement={{ _: /\d/ }}
              className="form-control"
              {...formik.getFieldProps("primaryContact.workPhone")}
              disabled={viewOnly}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className='input-label'>
              Cell Phone
            </label>
            <InputMask mask={inputMaskNumber}
              replacement={{ _: /\d/ }}
              className="form-control"
              {...formik.getFieldProps("primaryContact.cellPhone")}
              disabled={viewOnly}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className='input-label'>
              Fax
            </label>
            <InputMask mask={inputMaskNumber}
              replacement={{ _: /\d/ }}
              className="form-control"
              {...formik.getFieldProps("primaryContact.fax")}
              disabled={viewOnly}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className='input-label'>
              Pager
            </label>
            <InputMask mask={inputMaskNumber}
              replacement={{ _: /\d/ }}
              className="form-control"
              {...formik.getFieldProps("primaryContact.pager")}
              disabled={viewOnly}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <TextField
              label="Home Email"
              type="email"
              onChange={(e) => {
                const value = e.target.value.trim();
                formik.setFieldValue("primaryContact.homeEmail", value);
                if (value && !emailRegex.test(value)) {
                  setPrimaryHEmailErr(true);
                }
                else {
                  setPrimaryHEmailErr(false);
                }
              }}
              value={formik.values?.primaryContact?.homeEmail}
              // {...formik.getFieldProps("primaryContact.homeEmail")}
              disabled={viewOnly}
            />
          </div>
          {primaryHEmailErr &&
            <p className='mb-0 color-red'>
              Invalid Email Format
            </p>
          }
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <TextField
              label="Work Email "
              type="email"
              pattern=".+@example\.com"
              onChange={(e) => {
                const value = e.target.value.trim();
                formik.setFieldValue("primaryContact.workEmail", value);
                formik.setFieldValue("primaryContact.email", value);
                if (value && !emailRegex.test(value)) {
                  setPrimaryWEmailErr(true)
                }
                else {
                  setPrimaryWEmailErr(false)
                }
              }}
              value={formik.values?.primaryContact?.workEmail}
              onBlur={formik.handleBlur}
              disabled={viewOnly}
            />
          </div>
          {primaryWEmailErr &&
            <p className='mb-0 color-red'>
              Invalid Email Format
            </p>
          }
        </div>
        <div className="col-md-6">
          <div className="form-wrap">
            <label className="input-label">Preferred Method
              {/* <span className="text-danger">*</span> */}
            </label>
            <Select
              styles={customStyles}
              className="select"
              options={getContactLookup?.result?.preferredMethodTypes?.map((option: any) => ({
                label: option?.name,
                value: option?.id
              }))}
              value={
                formik.values?.primaryContact?.preferredMethod?.id
                  ? {
                    value: formik.values?.primaryContact?.preferredMethod?.id,
                    label: formik.values?.primaryContact?.preferredMethod?.name || '',
                  }
                  : null
              }
              isDisabled={viewOnly}
              onChange={(selectedOption: any) => {
                formik.setFieldValue('primaryContact.preferredMethod.id', selectedOption.value);
                formik.setFieldValue('primaryContact.preferredMethod.name', selectedOption.label);
              }}
            />
          </div>
        </div>
        <div className="col-md-6">
          <label className="input-label">
            Pref.Times
          </label>
          <TimePicker
            placeholder="Select Time"
            className="form-control datetimepicker-time"
            onChange={onChangePrimaryTime}
            // value={aptResultbyId?.result?.startTime}
            // defaultOpenValue={dayjs("12:00 AM", "h:mm A")}
            value={
              formik.values.primaryContact.perferredTime &&
                dayjs(formik.values.primaryContact.perferredTime, "h:mm A").isValid()
                ? dayjs(formik.values.primaryContact.perferredTime, "h:mm A")
                : null
            }
            format="h:mm A"
            use12Hours
            disabled={viewOnly}

          />
        </div>
      </>
      <div className='d-flex justify-content-end'>
        <h6 className='color-red p-3  text-decoration-underline cursor-pointer' onClick={hideShowDiv}> {toogle ? " Remove this secondary contact" : "Add secondary contact"}</h6>
      </div>
      {
        toogle === true &&
        <>
          <h5 className='mt-2 mb-2 '>Secondary Contact</h5>
          <div className="col-md-12">
            <div className="form-wrap">
              <label className="input-label">
                Contact Type{" "} <span className="text-danger">*</span>
              </label>
              <Select
                styles={customStyles}
                className="select"
                options={getContactLookup?.result?.contactTypes?.map((option: any) => ({
                  label: option?.name,
                  value: option?.id
                }))}
                value={
                  formik.values?.secondaryContact?.contactType?.id
                    ? {
                      value: formik.values?.secondaryContact?.contactType?.id,
                      label: formik.values?.secondaryContact?.contactType?.name || '',
                    }
                    : null
                }
                isDisabled={viewOnly}
                onChange={(selectedOption: any) => {
                  formik.setFieldValue('secondaryContact.contactType.id', selectedOption.value);
                  formik.setFieldValue('secondaryContact.contactType.name', selectedOption.label);

                }}
              />
            </div>
            {formik.touched.contactType && formik.errors.contactType && (
              <div className="error">{formik.errors.contactType?.id}</div>
            )}
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <TextField
                label=" Company Name"
                type="text"
                {...formik.getFieldProps("secondaryContact.companyName")}
                disabled={viewOnly}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className="input-label">
                Salutation{" "} <span className="text-danger">*</span>
              </label>
              <Select
                styles={customStyles}
                className="select"
                options={getContactLookup?.result?.salutationTypes?.map((option: any) => ({
                  label: option?.name,
                  value: option?.id
                }))}
                value={
                  formik.values?.secondaryContact?.salutation?.id
                    ? {
                      value: formik.values?.secondaryContact?.salutation?.id,
                      label: formik.values?.secondaryContact?.salutation?.name || '',
                    }
                    : null
                }
                isDisabled={viewOnly}
                onChange={(selectedOption: any) => {
                  formik.setFieldValue('secondaryContact.salutation.id', selectedOption.value);
                  formik.setFieldValue('secondaryContact.salutation.name', selectedOption.label);

                }}
              />
            </div>
            {formik.touched.salutation?.id && formik.errors.salutation?.id && (
              <div className="error">{formik.errors.salutation?.id}</div>
            )}
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <TextField
                label=" First Name"
                type="text"
                required
                {...formik.getFieldProps("secondaryContact.firstName")}
                disabled={viewOnly}
              />
            </div>
            {formik.touched.firstName && formik.errors.firstName && (
              <div className="error">{formik.errors.firstName}</div>
            )}
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <TextField
                label="Last Name"
                type="text"
                required
                {...formik.getFieldProps("secondaryContact.lastName")}
                disabled={viewOnly}
              />
            </div>
            {formik.touched.lastName && formik.errors.lastName && (
              <div className="error">{formik.errors.lastName}</div>
            )}
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <TextField
                label="Address As"
                type="text"
                {...formik.getFieldProps("secondaryContact.addressAs")}
                disabled={viewOnly}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className="input-label">Marital Status</label>
              <Select
                styles={customStyles}
                className="select"
                options={getContactLookup?.result?.maritalStatusTypes?.map((option: any) => ({
                  label: option?.name,
                  value: option?.id
                }))}
                value={
                  formik.values?.secondaryContact?.maritalStatus?.id
                    ? {
                      value: formik.values?.secondaryContact?.maritalStatus?.id,
                      label: formik.values?.secondaryContact?.maritalStatus?.name || '',
                    }
                    : null
                }
                isDisabled={viewOnly}
                onChange={(selectedOption: any) => {
                  formik.setFieldValue('secondaryContact.maritalStatus.id', selectedOption.value);
                  formik.setFieldValue('secondaryContact.maritalStatus.name', selectedOption.label);

                }}
              />
            </div>
          </div>
          <h5 className=' mb-2'>
            Contact Information
          </h5>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className='input-label'>
                Home Phone
              </label>
              <InputMask mask={inputMaskNumber}
                replacement={{ _: /\d/ }}
                className="form-control"
                {...formik.getFieldProps("secondaryContact.homePhone")}
                disabled={viewOnly}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className='input-label'>
                Work Phone
              </label>
              <InputMask mask={inputMaskNumber}
                replacement={{ _: /\d/ }}
                className="form-control"
                {...formik.getFieldProps("secondaryContact.workPhone")}
                disabled={viewOnly}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className='input-label'>
                Cell Phone
              </label>
              <InputMask mask={inputMaskNumber}
                replacement={{ _: /\d/ }}
                className="form-control"
                {...formik.getFieldProps("secondaryContact.cellPhone")}
                disabled={viewOnly}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className='input-label'>
                Fax
              </label>
              <InputMask mask={inputMaskNumber}
                replacement={{ _: /\d/ }}
                className="form-control"
                {...formik.getFieldProps("secondaryContact.fax")}
                disabled={viewOnly}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className='input-label'>
                Pager
              </label>
              <InputMask mask={inputMaskNumber}
                replacement={{ _: /\d/ }}
                className="form-control"
                {...formik.getFieldProps("secondaryContact.pager")}
                disabled={viewOnly}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <TextField
                label="Home Email"
                type="email"
                onChange={(e) => {
                  const value = e.target.value.trim();
                  formik.setFieldValue("secondaryContact.homeEmail", value);
  
                  if (value && !emailRegex.test(value)) {
                    setSecHEmailErr(true)
                  }
                  else {
                    setSecHEmailErr(false)
                  }
                }}
                value={formik.values?.secondaryContact?.homeEmail}

                onBlur={formik.handleBlur}
                disabled={viewOnly}
              />
            </div>
            {secHEmailErr &&
            <p className='mb-0 color-red'>
              Invalid Email Format
            </p>
          }
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <TextField
                label="Work Email "
                type="email"
                onChange={(e) => {
                  const value = e.target.value.trim();
                  formik.setFieldValue("secondaryContact.workEmail", value);
                  formik.setFieldValue("secondaryContact.email", value);
  
                  if (value && !emailRegex.test(value)) {
                    setSecWEmailErr(true)
                  }
                  else {
                    setSecWEmailErr(false)
                  }
                }}
                onBlur={formik.handleBlur}
                value={formik.values?.secondaryContact?.workEmail}

                disabled={viewOnly}
              />
            </div>
            {secWEmailErr &&
            <p className='mb-0 color-red'>
              Invalid Email Format
            </p>
          }
          </div>
          <div className="col-md-6">
            <div className="form-wrap">
              <label className="input-label">Preferred Method
              </label>
              <Select
                styles={customStyles}
                className="select"
                options={getContactLookup?.result?.preferredMethodTypes?.map((option: any) => ({
                  label: option?.name,
                  value: option?.id
                }))}
                value={
                  formik.values?.secondaryContact?.preferredMethod?.id
                    ? {
                      value: formik.values?.secondaryContact?.preferredMethod?.id,
                      label: formik.values?.secondaryContact?.preferredMethod?.name || '',
                    }
                    : null
                }
                isDisabled={viewOnly}
                onChange={(selectedOption: any) => {
                  formik.setFieldValue('secondaryContact.preferredMethod.id', selectedOption.value);
                  formik.setFieldValue('secondaryContact.preferredMethod.name', selectedOption.label);
                }}
              />
            </div>
          </div>
          <div className="col-md-6">
            <label className="input-label">
              Pref.Times
            </label>
            <TimePicker
              placeholder="Select Time"
              className="form-control datetimepicker-time"
              onChange={onChangeSecondaryTime}
              // value={aptResultbyId?.result?.startTime}
              defaultOpenValue={dayjs("12:00 AM", "h:mm A")}
              format="h:mm A"
              use12Hours
              disabled={viewOnly}
              value={
                formik.values.secondaryContact.perferredTime &&
                  dayjs(formik.values.secondaryContact.perferredTime, "h:mm A").isValid()
                  ? dayjs(formik.values.secondaryContact.perferredTime, "h:mm A")
                  : null
              }
            />
          </div>
        </>
      }
    </div >
  )
}

export default ContactWizData